"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDismissInterstitial = void 0;
const features_1 = require("../../features");
const initializer_1 = require("../../initializer");
const react_1 = require("react");
const useDismissInterstitialBase_hook_1 = require("./useDismissInterstitialBase.hook");
const useDismissInterstitial = () => {
    const interstitialsRepository = (0, react_1.useRef)(new features_1.InterstitialsRepository(initializer_1.API));
    return (0, useDismissInterstitialBase_hook_1.useDismissInterstitialBase)(interstitialsRepository.current);
};
exports.useDismissInterstitial = useDismissInterstitial;
//# sourceMappingURL=useDismissInterstitial.hook.js.map